export const materialAdapter =
    ({
       material_id,
       name,
       artikul,
       barcode,
       price,
       sale_price,
       material_group_id,
       available_for_sale,
       new_order_amount,
       min_stock,
       unit_id,
       flag
     }) => ({
      material_id: material_id ?? null,
      name: name ?? null,
      artikul: artikul ?? null,
      barcode: barcode ?? null,
      price: price ?? null,
      sale_price: !available_for_sale ? 0 : (sale_price ?? null),
      material_group_id: material_group_id ?? null,
      new_order_amount: new_order_amount ?? null,
      min_stock: min_stock ?? null,
      unit_id: unit_id ?? null,
      available_for_sale: available_for_sale ? 1 : 0,
      flag: flag ?? null

    })
